<template>
  <div class="node">
    <div class="node-row">
      <div class="link"
           @click="copyLink()"
      >
        <i class="fas fa-external-link-square-alt"></i>
      </div>
      <i class="far"
         :class="[faIconName]"
         @click="open = !open"
      ></i>
      <span class="node-label"
            @click="openLink()"
      >{{ name }}</span>
    </div>
    <div v-if="isOpen"
         style="margin-left: 20px"
    >
      <FilebrowserNode
        v-for="c in children"
        :key="c.name"
        :data="c"
        :depth="depth + 1"
        :sorting="sorting"
        :autoOpenDepth="autoOpenDepth"
        :parentPath="`${parentPath}/${name}`"
      ></FilebrowserNode>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
const guessExtension = filename => filename.split('.').pop()

export default {
    name: 'FilebrowserNode',
    components: {
    },
    props: {
        data: {
            required: true,
            type: Object,
        },
        depth: {
            required: false,
            type: Number,
            default: _ => 0,
        },
        sorting: {
            required: false,
            type: Object,
            default: _ => {return {}},
        },
        autoOpenDepth: {
            required: false,
            type: Number,
            default: _ => 0,
        },
        parentPath: {
            required: false,
            type: String,
            default: _ => '/',
        },
    },
    data() {
        return {
            open: false,
        }
    },
    computed: {
        name() {
            return _.get(this.data, 'name', '<bez nazvu>')
        },
        children() {
            return _.get(this.data, 'children', [])
        },
        faIconName() {
            const type = _.get(this.data, 'type')
            if (type === 'FOLDER') {
                if (this.isOpen) {
                    return 'fa-folder-open'
                }
                return 'fa-folder'
            } else if (type === 'FILE') {
                const ext = guessExtension(this.name)
                switch (ext) {
                    case 'doc':
                    case 'docx':
                        return 'fa-file-word'
                    case 'pdf':
                        return 'fa-file-pdf'
                    case 'jpg':
                    case 'jpeg':
                    case 'psd':
                    case 'png':
                    case 'bmp':
                        return 'fa-file-image'
                    case 'xls':
                    case 'xlsx':
                        return 'fa-file-excel'
                    case 'txt':
                    default:
                        return 'fa-file'
                }
            } else {
                return 'fa-question-circle'
            }
        },
        isOpen() {
            return this.open || this.autoOpenDepth > this.depth
        },
    },
    mounted() {

    },
    methods: {
        async copyLink() {
            const winPath = this.parentPath.replaceAll('/', '\\')
            const winName = this.name.replaceAll('/', '\\')
            await navigator.clipboard.writeText(`${winPath}\\${winName}`)
            this.flash('Odkaz zkopírován do clipboardu', 'success', {
                timeout: 2000,
            })
        },
        async openLink() {
            const winPath = this.parentPath.replaceAll('/', '\\')
            const winName = this.name.replaceAll('/', '\\')
            axios.get(`http:\\\\localhost:8080/?file=${winPath}\\${winName}`)
        },
    },
}
</script>

<style scoped>
.node > .far {
    cursor: pointer;
}
.node {
    margin: 3px 0;
}
.node-label {
    margin: 0 auto 0 4px;
    cursor: pointer;
}
.node-label:hover {
    text-decoration: underline;
    color: var(--primary);
}
.node-row {
    display: flex;
    flex-direction: row;
}
.node-row > i:first-child {
    width: 14px;
}
.node-row:hover {
    background-color: LemonChiffon;
}
.node-row .link:hover {
    cursor: pointer;
    color: var(--warning);
}
.link {
    margin-right: 5px;
}
</style>

